<template>
  <v-container class="text-left" fluid>
    <v-row>
      <v-col md="12">
        <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
        <v-data-table
          :headers="headers"
          :options.sync="options"
          :server-items-length="serverItemsLength"
          v-show="!loading"
          :items="partners"
        >
          <template v-slot:item.confirmed="{ item }">
            <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
            <v-icon v-else color="error">fa-times</v-icon>
          </template>
          <template v-slot:item.id="{ item }">
            <v-btn
              color="primary"
              :to="'/super-admin/partner/' + item.id"
              @click.prevent="reload()"
              >Details</v-btn
            >
            <span>&nbsp;</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="item.state == 4"
                  :id="item.id"
                  v-on="on"
                  outlined
                  small
                  color="secondary"
                  @click.prevent="showEditPanel(item.user_id)"
                >
                  <v-icon small>fa-pencil-alt</v-icon>
                </v-btn>
              </template>
              <span>Edit User </span>
            </v-tooltip>
            <!-- Suspend icon -->
            <v-tooltip bottom v-if="item.state != 4">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="error"
                  class="ml-1"
                  outlined
                  small
                  @click.prevent="updateState(item.id, 'suspend')"
                >
                  <v-icon small>fa fa-ban</v-icon>
                </v-btn>
              </template>
              <span>Suspend Partner</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="error"
                  class="ml-1"
                  outlined
                  small
                  @click.prevent="updateState(item.id, 'active')"
                >
                  <v-icon small>fa fa-undo</v-icon>
                </v-btn>
              </template>
              <span>Active Partner</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import superAdminAPI from '@/api/superadmin.js';
import partnerAPI from '@/api/partner.js';
import LayoutBasic from '@/layouts/Dashboard';
import EditUser from '@/components/superadmin/users/Edit';
import CreateUser from '@/components/admin/users/Create';
import ViewDetails from '@/components/admin/users/View';
export default {
  name: 'SuperAdminCompanyUsers',
  components: {
    LayoutBasic,
  },
  props: {
    userId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Company', value: 'company_name' },
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'State', value: 'state_description' },
        // { text: 'Live Customer', value: '', sortable: false },
        // { text: 'On Trial', value: '', sortable: false },
        { text: 'Last Login', value: 'last_login', sortable: false },
        //{ text: "Courses", value: "total_courses", sortable: false },
        { text: '', value: 'id', align: 'end' },
      ],
      partnerId: this.$route.params.id,
      partners: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      confirmDelete: 'Are you sure you wish to delete this user?',
      confirmUpdatePartnerState: 'Are you sure you wish to update state to ',
      successUpdateStateMessage: 'State has been updated Successfully',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
  },
  watch: {
    options: {
      handler() {
        this.getTier2Partner();
      },
      deep: true,
    },
  },
  methods: {
    getTier2Partner() {
      this.loading = true;
      partnerAPI
        .getPartners(
          this.params + '&include=users',
          this.searchParams,
          this.userId
        )
        .then((resp) => {
          this.partners = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = '';
      this.getUsers();
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        this.params = payload;
        this.getUsers();
      });
    },
    applySearch() {
      this.searchParams =
        this.params +
        '&search=first_name:' +
        this.search +
        ';last_name:' +
        this.search;
      this.getUsers();
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    reload() {
      location.reload();
    },
    updateState(id, state = '') {
      var confirmUpdatePartnerState =
        this.confirmUpdatePartnerState + state + '?';
      this.$snotify.confirm(confirmUpdatePartnerState, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
             className: 'toast-continue-button',
            action: (toast) => this.processUpdatePartnerState(toast, id, state),
          }          
        ],
      });
    },
    processUpdatePartnerState(toast, id, state) {
      this.$snotify.remove(toast.id);
      this.loading = true;

      partnerAPI.updatePartnerState(id, state).then(() => {
        this.getTier2Partner();
        this.$snotify.success(this.successUpdateStateMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
  },
};
</script>
